import { render, staticRenderFns } from "./CompanyDetails.vue?vue&type=template&id=3a41e93d&scoped=true&"
import script from "./CompanyDetails.vue?vue&type=script&lang=js&"
export * from "./CompanyDetails.vue?vue&type=script&lang=js&"
import style1 from "@/assets/css/form.css?vue&type=style&index=1&id=3a41e93d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a41e93d",
  null
  
)

export default component.exports